
import { SearchService } from './../../../services/search.service';
import { Component, OnInit,Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { AuthService } from './../../../services/auth.service';
import { Router } from  '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BookingService } from 'src/app/services/booking.service';
import { ViewBookingModel } from 'src/app/models/Booking/ViewBookingModel';


@Component({
  selector: 'app-cancel-confirmation-modal',
  templateUrl: './cancel-confirmation-modal.component.html',
  styleUrls: ['./cancel-confirmation-modal.component.scss']
})
export class CancelConfirmationModalComponent implements OnInit {




  faTimesCircle=faTimesCircle;
  currency;
  caseId;
  viewBooking: ViewBookingModel;
  refundableAmountValue;

  constructor(
    private bookinService:BookingService,
    private searchService: SearchService,
    private bookingService:BookingService,
    private dialogRef: MatDialogRef<CancelConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private formBuilder: FormBuilder,
    public translateService: TranslateService, ) {
      this.currency = searchService.getCurrency();
    }

  ngOnInit() {
    this.caseId= this.bookinService.CaseID;
    this.bookinService.viewBookingModel.subscribe(res=>{
      this.viewBooking=res;

    })

   if(this.data != null){

    this.refundableAmountValue= this.data.refundableAmountValue;

   }



  }

  close(): void {
    this.dialogRef.close();
    this.bookinService.updateViewBookingState();
    //location.reload();
  }

}
